import * as linkify from "linkifyjs";

const getValidUrl = (text: string): string[] =>
  linkify.find(text).map(({ href }) => href);

export default getValidUrl;
